import { ButtonBase, Stack, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { CalloutContent } from "web_myplann/Shared/Components/CalloutContent";

export type CalloutColor = "blue" | "amber" | "green" | "red";

type Props = {
	color: CalloutColor;
	icon: LucideIcon;
	title: string;
	description: string;
	onClick?: () => void;
};

export const Callout: FC<Props> = ({
	color,
	icon,
	title,
	description,
	onClick,
}) => {
	const theme = useTheme();
	const tint = theme.palette[color];

	if (!onClick) {
		return (
			<Stack
				sx={{
					bgcolor: tint[50],
					border: theme.colors.border.solid(tint[100]),
					borderRadius: theme.radii.lg,
					p: 1.6,
				}}
			>
				<CalloutContent
					color={color}
					icon={icon}
					title={title}
					description={description}
					showChevron={false}
				/>
			</Stack>
		);
	}

	return (
		<ButtonBase
			onClick={onClick}
			sx={{
				bgcolor: tint[50],
				border: theme.colors.border.solid(tint[100]),
				borderRadius: theme.radii.lg,
				p: 1.6,
				width: "100%",
				textAlign: "left",
				"&:active": { transform: "scale(0.99)" },
			}}
		>
			<CalloutContent
				color={color}
				icon={icon}
				title={title}
				description={description}
				showChevron
			/>
		</ButtonBase>
	);
};
